import React from 'react';
import CashPeriod from "../containers/CashPeriod/CashPeriod";

export const CashPeriodPage: React.FC = () => <CashPeriod />;

